import { useState, useEffect } from "react";
import { useStore } from "react-redux";
import _ from "lodash";

import { Card } from '@mui/material';

import { ListDisplay } from '../../ListDisplay/ListDisplay';

import { constants } from '../../../Constants/constants';
import { getList } from "../../../helper/baseFetch";

export const UserGroupList = ({ onClickListRow, editBtn, createBtn, listOverflow }) => {
  const store = useStore();
  const [userGroupList, setUserGroupList] = useState([]);
  const [ready, setReady] = useState(false);
  const resource = "productCreateUserGroupList";

  const userGroupTitleList = [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "groupCode",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "groupDesc",
      sort: true
    },
  ];
  const listFilters = [
    {
      className: "filter-input",
      label: { resource: resource, key: "groupCode" },
      clear: true,
      value: '',
      name: "groupCode",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "groupDesc" },
      clear: true,
      value: '',
      name: "groupDesc",
      size: constants.SIZE.SMALL
    },
  ];

  const [param, setParam] = useState({
    path: "",
    page: 0,
    rowsPerPage: 10,
    sort: 'updateTimestamp',
    direction: 'DESC',
    listFilters: listFilters,
    count: 0,
  })

  function onChangeParam(value) {
    value.count = value.count + 1;
    setParam(value);
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param);
    tempParam.listFilters = list;
    tempParam.page = 0;
    onChangeParam(tempParam);
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param);
    tempParam.sort = sortItem;
    tempParam.direction = tempParam.direction === "DESC" ? "ASC" : "DESC";
    onChangeParam(tempParam);
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = page;
    onChangeParam(tempParam);
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = 0;
    tempParam.rowsPerPage = rowsPerPage;
    onChangeParam(tempParam);
  }

  useEffect(() => {
    let tempParam = _.cloneDeep(param);
    const filter = {};
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value;
      }
    })

    getList(constants.PATH.PRODUCT.USER_GROUP, { sort: { field: tempParam.sort, order: tempParam.direction }, filter: filter, pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage } }, (payload) => {
      setUserGroupList(payload);
      setReady(true)
    }, undefined, store);

  }, [param.count]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready &&
    <Card className="card-wrapper overflow">
      <ListDisplay
        listOverflow={listOverflow}
        onClickListRow={onClickListRow}
        page={param.page}
        rowsPerPage={param.rowsPerPage}
        onChangeListSort={onChangeListSort}
        resource={resource}
        dataList={userGroupList}
        sort={param.sort}
        direction={param.direction}
        listTitles={userGroupTitleList}
        listFilters={param.listFilters}
        onChangeListPage={onChangeListPage}
        onChangeListRowsPerPage={onChangeListRowsPerPage}
        onChangeListFilters={onChangeListFilters}
        editBtn={editBtn}
        createBtn={createBtn}
        redirectPath={"/" + constants.PATH.PRODUCT.USER_GROUP + "/"}
      />
    </Card>
  )
};